module.exports = __webpack_public_path__ + "media/images/icons/google-c7ffe836b214edc99580e9a1c19a8cb67a63c5b89192edf10064b66d04ad9adc.png";